import React from 'react';
import { useNavigate } from 'react-router-dom';
import CourseBuilder from '../components/CourseBuilder';

function CreateCoursePage() {
  const navigate = useNavigate();
  
  const handleSuccess = () => {
    navigate('/coach-dashboard');
  };
  
  const handleClose = () => {
    navigate('/coach-dashboard');
  };
  
  return (
    <CourseBuilder 
      onSuccess={handleSuccess}
      onClose={handleClose}
    />
  );
}

export default CreateCoursePage;
